export class SubHistoryModel {
    history_sequence: string
    link_no: string
    link_type: string
    unit: string
    procedure_desc: string
    method_of_issue: string

    constructor(
        history_sequence: string,
        link_no: string,
        link_type: string,
        unit: string,
        procedure_desc: string,
        method_of_issue: string
    ) {
        this.history_sequence = history_sequence
        this.link_no = link_no
        this.link_type = link_type
        this.unit = unit
        this.procedure_desc = procedure_desc
        this.method_of_issue = method_of_issue
    }
}